import { useMemo, useCallback, useContext } from 'react';
import ReactEcharts from 'echarts-for-react';
import Head from '@/containers/chart_box/Head';
import Body from '@/containers/chart_box/Body';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
// import { sinTimeDimensionSinIndexMulValue } from '@/utils/reportResponseUtil';
import { fmtThousand } from '@/utils/comUtil';
const FunnelDistribution = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const { charts } = themeContext[brandContext];
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const {
    loading,
    data = [],
    title,
    REGISTER_RATECOPY = [],
    BUY_RATECOPY = [],
  } = props;
  const reg =
    REGISTER_RATECOPY.length > 0 &&
    Number(REGISTER_RATECOPY[0].values[1].value);
  const buy =
    BUY_RATECOPY.length > 0 && Number(BUY_RATECOPY[0].values[1].value);
  //   const reg = REGISTER_RATECOPY && Number(0.3423);
  //   const buy = BUY_RATECOPY && Number(0.5343);

  // 漏斗各环节的真实数值单独抽出来缓存，tooltip 回调依赖它才能保持引用稳定
  const seriesData = useMemo(() => {
    if (!data || data.length === 0) {
      return null;
    }
    const pickFirst = (index) => {
      const list = data.filter((item) => {
        return item.index === index;
      });
      list.sort((a, b) => {
        return a.values[2].value - b.values[2].value;
      });
      return list[0];
    };
    const PV = pickFirst('PV');
    const UV = pickFirst('UV');
    const REGISTER = pickFirst('REGISTER');
    const BUY = pickFirst('BUY');
    return [
      { name: PV.index, value: PV.values[1].value },
      { name: UV.index, value: UV.values[1].value },
      { name: '注册', value: REGISTER.values[1].value },
      { name: '购买', value: BUY.values[1].value },
    ];
  }, [data]);

  const tooltipFormatter = useCallback(
    (p) => {
      const index = p.dataIndex;
      const ReallyData = seriesData[index];
      return `新会员注册+销售追踪<br/>${ReallyData.name}:${fmtThousand(
        ReallyData.value,
      )}`;
    },
    [seriesData],
  );

  const labelFormatter = useCallback(
    (p) => {
      const index = p.dataIndex;
      const ReallyData = seriesData[index];
      return `${ReallyData.name}\n${fmtThousand(ReallyData.value)}`;
    },
    [seriesData],
  );

  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const option = useMemo(() => {
    if (!seriesData) {
      return null;
    }

    return {
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      tooltip: {
        trigger: 'item',
        textStyle: {
          fontSize: chartsFontSize.s03,
        },
        formatter: tooltipFormatter,
      },
      color: charts.barColorList,
      series: [
        {
          name: '新会员注册+销售追踪',
          type: 'funnel',
          data: [
            {
              value: 80,
              name: seriesData[0].name,
              itemStyle: { color: '#1565C0' },
            },
            {
              value: 60,
              name: seriesData[1].name,
              itemStyle: { color: '#1976D2' },
            },
            { value: 40, name: '注册', itemStyle: { color: '#2196F3' } },
            { value: 20, name: '购买', itemStyle: { color: '#999999' } },
          ],
          sort: 'descending',
          gap: 2,
          avoidLabelOverlap: false,
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 2,
            label: true,
          },
          width: '80%',
          label: {
            show: true,
            position: 'inside',
            formatter: labelFormatter,
          },
          labelLine: {
            show: true,
          },
        },
      ],
    };
  }, [
    charts.barColorList,
    chartsFontSize.s03,
    fontFamily,
    labelFormatter,
    seriesData,
    tooltipFormatter,
  ]);

  return (
    <>
      <Head boxId={title}></Head>
      <Body bizData={data} loading={loading}>
        {option && (
          <ReactEcharts
            style={{ width: '100%', height: '100%' }}
            option={option}
            notMerge={true}
            lazyUpdate={true}
          />
        )}
        <div
          style={{
            width: '100px',
            position: 'absolute',
            left: '320px',
            bottom: '170px',
            color: '#2196F3',
            fontWeight: '600',
          }}
        >
          <p>
            <span
              style={{
                display: 'inline-block',
                width: '18px',
                height: '2px',
                borderTop: '2px solid #000',
                marginBottom: '2px',
              }}
            ></span>
            <span
              style={{
                display: 'inline-block',
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                backgroundColor: '#000',
              }}
            ></span>{' '}
            注册转化率
          </p>
          <p style={{ textAlign: 'center', marginLeft: '28px' }}>
            {(reg * 100).toFixed(2)}%
          </p>
        </div>
        <div
          style={{
            width: '150px',
            position: 'absolute',
            left: '284px',
            bottom: '110px',
            color: '#999999',
            fontWeight: '600',
          }}
        >
          <p style={{ color: '#333' }}>
            <span
              style={{
                display: 'inline-block',
                width: '52px',
                height: '2px',
                borderTop: '2px solid #000',
                marginBottom: '2px',
              }}
            ></span>
            <span
              style={{
                display: 'inline-block',
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                backgroundColor: '#000',
              }}
            ></span>{' '}
            购买转化率
          </p>
          <p style={{ textAlign: 'center', marginLeft: '40px', color: '#333' }}>
            {(buy * 100).toFixed(2)}%
          </p>
        </div>
      </Body>
    </>
  );
};
export default FunnelDistribution;
